export default __webpack_public_path__ + "static/media/sent.a834bef1.svg";